import { useMemo } from "react";
import { Card, Form, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { updateUserProfileApi } from "../../api/api";
import { handleError } from "../../helpers/handleError";
import brandLogo from "../../assets/image/logo.e3c0b2196cc23f84f67a.png";
import "./login.css";

export default function CompleteProfile() {
  const navigate = useNavigate();
  const location = useLocation();
  const token = useSelector((s) => s.auth?.accessToken);
  const currentName = useSelector((s) => s.auth?.user?.name) || "";
  const currentDni = useSelector((s) => s.auth?.user?.dni) || "";
  const email = useSelector((s) => s.auth?.user?.email) || "";

  const from = useMemo(() => {
    const prev = location?.state?.from;
    if (typeof prev === 'string' && prev) return prev;
    return "/myevents";
  }, [location?.state]);

  const { register, handleSubmit, formState: { errors }, setValue } = useForm({
    defaultValues: { name: currentName, dni: currentDni, phone: "" },
  });

  const onSubmit = async (data) => {
    try {
      if (!token) { navigate("/login", { replace: true, state: { from } }); return; }
      const payload = { name: data.name, dni: data.dni, phone: data.phone };
      try { await updateUserProfileApi(token, payload); } catch (e) { /* backend opcional */ }
      navigate(from, { replace: true });
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <div className="login-container pading150">
      <div className="login-logo-wrap">
        <img
          className="login-logo"
          src={brandLogo}
          alt="Zoco"
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/event')}
        />
      </div>
      <Card className="login-card">
        <Card.Body style={{ padding: 0 }}>
          <h2 className="login-title">Completá tus datos</h2>
          <p className="register-subtext" style={{ marginTop: -8 }}>No importamos tu información de Google. Ingresala acá.</p>

          <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group className="mb-4">
              <Form.Control
                type="text"
                placeholder="Nombre y apellido *"
                {...register("name", { required: "El nombre es obligatorio" })}
                className="login-input"
              />
              {errors.name && <p className="field-error">{errors.name.message}</p>}
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Control
                type="text"
                inputMode="numeric"
                maxLength={7}
                placeholder="DNI *"
                {...register("dni", {
                  required: "El DNI es obligatorio",
                  pattern: { value: /^\d+$/, message: "Solo números" },
                  minLength: { value: 7, message: "Debe tener 7 dígitos" },
                  maxLength: { value: 7, message: "Debe tener 7 dígitos" }
                })}
                onInput={(e) => { e.target.value = (e.target.value || '').replace(/\D+/g, '').slice(0,7); }}
                className="login-input"
              />
              {errors.dni && <p className="field-error">{errors.dni.message}</p>}
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Control
                type="tel"
                placeholder="Teléfono (opcional)"
                {...register("phone")}
                className="login-input"
              />
            </Form.Group>

            <Button type="submit" className="login-button">Guardar y continuar</Button>
          </Form>

          <div className="login-links-row" style={{ justifyContent: 'center' }}>
            <span>Tu email: <strong>{email}</strong></span>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}
